module.exports = __webpack_public_path__ + "static/img/velvetAshesTestimonial.6944e65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/velvet-ashes/velvetAshesTestimonial.jpg
// module id = 51
// module chunks = 0